import { gql } from '@apollo/client';

export const JobApplicationCoreFields = gql`
  fragment JobApplicationCoreFields on JobApplication {
    id
    jobId
    userId
    clientId
    itemStatus
    createdAt
    updatedAt
    clientRateInCents
    workerRateInCents
    coverLetter
  }
`;
export const GET_JOB_APPLICATIONS_FOR_USER = gql`
  ${JobApplicationCoreFields}
  query GetJobApplicationsForUser($userId: String!) {
    getJobApplicationsForUser(userId: $userId) {
      ...JobApplicationCoreFields
    }
  }
`;
export const GET_JOB_APPLICATIONS_FOR_CLIENT = gql`
  ${JobApplicationCoreFields}
  query GetJobApplicationsForClient($clientId: String!) {
    getJobApplicationsForClient(clientId: $clientId) {
      ...JobApplicationCoreFields
    }
  }
`;
export const GET_JOB_APPLICATIONS_FOR_JOB = gql`
  ${JobApplicationCoreFields}
  query GetJobApplicationsForJob($jobId: String!) {
    getJobApplicationsForJob(jobId: $jobId) {
      ...JobApplicationCoreFields
    }
  }
`;

export const RESPOND_TO_APPLICATION = gql`
  mutation RespondToApplication(
    $id: String!
    $status: JobApplicationStatus!
    $finalWorkerPayRateCents: Int
    $finalClientPayRateCents: Int
  ) {
    respondToApplication(
      id: $id
      status: $status
      finalWorkerPayRateCents: $finalWorkerPayRateCents
      finalClientPayRateCents: $finalClientPayRateCents
    )
  }
`;
